export function convertDatesToUnix<T extends { [key: string]: any }>(obj: T): T {
  const newObj: T = { ...obj };
  for (const key in newObj) {
    if ((newObj[key] as any) instanceof Date) {
      newObj[key] = (newObj[key] as Date).getTime() as T[Extract<keyof T, string>];
    }
  }
  return newObj;
}
